var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClimatechange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    width: 406,
    height: 306,
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 3619.9785,
    y1: 4094.9836,
    x2: 1120.0347,
    y2: 990.2103
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#DAE3FE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9EFFD"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M2928.852,2872.904c-57.238,60.579-111.395,99.646-154.185,130.511 c-502.976,362.818-1098.129,257.058-1224.616,231.23c-186.781-38.139-547.826-111.861-808.855-420.464 c-394.915-466.892-333.421-1202.466-27.098-1688.029c56.031-88.818,352.004-581.777,953.568-660.832 c364.06-47.843,788.437,48.651,1095.759,307.501C3408.522,1316.17,3362.598,2413.831,2928.852,2872.904z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M1333.595,2151.956c0,0-72.433-1009.191-492.276-1619.241 c-28.223-41.009-94.305-37.242-116.414,6.782C577.071,833.87,230.746,1742.746,1333.595,2151.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M1240.217,2073.01c2.146,2.717-1.92,5.847-4.441,3.42 c-92.943-89.484-438.379-511.776-460.033-1249.072c-0.069-2.368,3.743-2.671,4.034-0.316 C801.211,1000.515,900.911,1643.406,1240.217,2073.01z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.68
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1185.53,2651.14c-59.284-172.24-307.374-852.419-644.784-1213.693 c-24.092-25.797-72.862-15.648-75.463,19.359c-15.089,203.102-83.268,840.111,694.458,1217.719 C1174.709,2681.792,1190.913,2666.78,1185.53,2651.14z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "#FFFFFF"
    },
    d: "M1155.992,2658.949c-1.859-0.512-3.599-1.537-4.994-3.062 C894.66,2374.974,750.926,2121.37,675.49,1958.085c-81.952-177.38-102.817-286.641-103.664-291.207 c-1.068-5.74,2.722-11.257,8.461-12.322c5.734-1.083,11.258,2.719,12.329,8.455c0.82,4.392,87.609,445.601,574.003,978.615 c3.936,4.318,3.63,11.003-0.684,14.94C1163.15,2659.11,1159.376,2659.881,1155.992,2658.949z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "2381.102,1060.74 1509.211,972.601 635.893,1055.683 619.779,2988.625 1492.739,2948.563 2364.857,3009.392 3237.006,2936.2 3252.95,1023.585  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "1511.835,2904.663 682.409,2942.656 697.695,1108.99 1527.462,1030.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#BDD0FB"
    },
    points: "2340.464,2962.38 1511.835,2904.663 1527.462,1030.188 2355.875,1113.811  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#91B3FA"
    },
    points: "3169.12,2892.958 2340.464,2962.38 2355.875,1113.811 3184.245,1078.576  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500.875,
    y: 1030.071,
    transform: "matrix(1 0.0089 -0.0089 1 17.606 -13.3895)",
    style: {
      opacity: 0.47,
      fill: "#FFFFFF"
    },
    width: 18.772,
    height: 1875.055
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.84
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033329618759035038350000014007859253583419549_",
    gradientUnits: "userSpaceOnUse",
    x1: 2111.3044,
    y1: 2312.9805,
    x2: 2145.1641,
    y2: 2312.9805
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033329618759035038350000014007859253583419549_)"
    },
    d: "M2119.571,2271.19 c-3.344,26.154-6.067,52.393-8.166,78.686c-0.501,6.273,0.721,14.799,6.777,15.412c3.646,0.369,6.681-2.688,9.138-5.5 c10.434-11.937,21.643-27.332,16.595-42.555c-1.878-5.665-5.877-10.43-7.416-16.204c-2.314-8.683,1.313-17.924,0.38-26.879 s-11.692-17.764-17.716-11.261L2119.571,2271.19z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096056744795920965190000005164030191766920364_",
    gradientUnits: "userSpaceOnUse",
    x1: 797.7921,
    y1: 1835.5006,
    x2: 1510.0577,
    y2: 1835.5006
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000096056744795920965190000005164030191766920364_)"
    },
    d: "M1448.303,1410.863 c-41.037-21.691-66.847-24.625-111.029-19.816c-41.674,4.537-69.834,25.473-98.446,55.308 c-6.509,6.787-12.832,14.213-21.271,18.109c-35.36,16.324-80.206,13.034-116.314,29.147 c-42.98,19.18-55.106,78.835-94.362,105.211c-22.724,15.268-51.36,17.199-76.312,28.125 c-36.938,16.175-53.973,49.771-74.951,82.468c-12.899,20.106-60.409,54.558-57.716,78.073c0.491,4.282,2.286,8.306,4.537,11.935 c13.082,21.087,32.621,23.308,53.236,29.33c27.236,7.957,43.666,20.18,67.763,37.224c25.131,17.776,59.322,33.322,61.497,64.736 c1.01,14.577-5.794,28.352-9.121,42.555c-15.008,64.059,40.686,121.601,94.892,156.244 c54.207,34.642,118.163,68.866,135.404,132.321c1.571,5.784,2.894,12.059,7.102,16.198 c15.825,15.568,27.676-19.648,32.471-30.844c3.086-7.208,0.29-15.862-4.534-21.965c-4.825-6.104-11.406-10.384-17.339-15.332 c-20.021-16.696-33.008-42.12-35.06-68.638c-0.261-3.371-0.285-7.019,1.56-9.812c9.397-14.224,32.818-20.06,44.306-37.294 c16.435-24.656,20.187-48.051,22.984-77.312c10.277-107.503,108.152-69.448,169.592-117.116 c11.437-8.873,20.033-22.882,22.001-37.194c1.085-7.892,0.156-15.877-3.424-23.143c-6.047-12.278-18.415-20.178-31.289-23.714 c-12.874-3.536-26.399-3.278-39.717-2.996c-12.36,0.262-24.72,0.523-37.081,0.785c-3.654,0.077-7.417,0.178-10.767,1.689 c-4.734,2.135-7.941,6.757-10.508,11.394c-8.269,14.938-12.346,32.327-11.613,49.524c-16.292,5.728-32.112-9.804-41-25.047 c-10.259-17.595-17.633-36.985-21.714-57.094c-1.577-7.77-2.545-16.37,1.341-23.216c2.142-3.776,5.547-6.586,8.982-9.144 c13.839-10.309,29.805-18.101,46.764-19.955c28.963-3.166,57.114,11.123,80.857,28.641 c22.803,16.821,59.994,36.95,85.579,12.777c13.209-12.48,13.445-35.197,4.243-51.067c-14.948-25.776-53.066-39.262-77.901-52.28 c-11.625-6.093-19.091-18.633-22.391-31.675c-3.302-13.042-2.987-26.731-2.651-40.208c34.373-14.046,74.769-11.299,107.07,7.281 c4.584,2.637,9.474,6.306,10.016,11.703c0.557,5.546-3.682,10.176-7.026,14.552c-29.731,38.899-3.006,70.307,31.98,92.258 c0.835-98.63,1.059-197.766,1.116-296.499C1488.831,1430.095,1468.143,1421.35,1448.303,1410.863z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005971491034592361100000009560106096578566570_",
    gradientUnits: "userSpaceOnUse",
    x1: 1508.9418,
    y1: 1606.8329,
    x2: 1761.1017,
    y2: 1606.8329
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005971491034592361100000009560106096578566570_)"
    },
    d: "M1759.088,1494.387 c-4.788-6.457-14.294-4.829-22.161-4.778c-25.124,0.163-45.084-21.744-69.236-28.91c-12.655-3.755-26.054-3.328-39.218-3.528 c-40.142-0.61-80.166-7.469-118.415-20.079c-0.057,98.733-0.281,197.869-1.116,296.499 c21.805,13.681,46.817,23.691,63.378,29.544c17.571,6.212,34.346,16.426,53.127,12.604c17.431-3.547,33.115-23.228,51.18-28.242 c13.086-3.632,27.06-1.726,40.343-4.486s27.129-13.057,26.579-27.061c-0.448-11.403-10.137-19.981-19.776-25.531 c0,1.089-16.702-12.578-18.284-15.538c-14.573-29.209,6.617-54.936,14.726-80.152c11.74-36.509-5.647-57.973,30.465-78.191 C1758.361,1512.239,1764.403,1501.555,1759.088,1494.387z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103946854583881186590000001532734146657498525_",
    gradientUnits: "userSpaceOnUse",
    x1: 1227.2655,
    y1: 2523.8652,
    x2: 1450.3429,
    y2: 2523.8652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000103946854583881186590000001532734146657498525_)"
    },
    d: "M1271.071,2418.903 c6.289,13.245,11.449,25.75,12.82,36.398c5.959,46.31-32.587,103.295-48.975,145.575c-4.558,11.758-9.203,24.27-7.15,36.759 c0.865,5.261,2.889,10.23,4.906,15.143c14.882,36.258,44.121,69.074,70.099,97.035c8.882-23.972,8.225-81.539,5.787-107.077 c-0.804-8.423-2.208-17.239,0.791-25.113c9.619-25.255,40.927-60.004,62.515-75.068c21.16-14.765,48.969-26.619,54.453-52.407 c2.109-9.915,0.334-20.533,3.438-30.164c1.861-5.774,5.358-10.802,8.148-16.166c13.687-26.318,21.454-77.122-5.953-95.816 c-30.635-20.896-73.993,9.708-100.279-24.377c-3.966-5.142-6.92-11.131-11.432-15.766c-8.373-8.602-21.238-11.324-32.879-9.31 C1209.877,2311.961,1248.04,2370.396,1271.071,2418.903z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163771987505327553480000012665907575986454970_",
    gradientUnits: "userSpaceOnUse",
    x1: 1739.396,
    y1: 1801.9924,
    x2: 3015.356,
    y2: 1801.9924
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163771987505327553480000012665907575986454970_)"
    },
    d: "M1757.613,2036.338 c24.467,16.188,66.701-19.326,82.231-60.843c1.944-5.197,3.745-10.622,7.305-14.804c7.247-8.515,19.713-9.605,30.574-8.034 s21.69,5.175,32.568,3.732c15.609-2.071,28.502-14.466,35.791-28.894c7.289-14.428,9.911-30.814,12.434-46.883 c11.547-2.945,24.029-1.81,34.902,3.173c8.396,3.848,16.685,12.331,14.341,21.516c-1.076,4.218-4.189,7.497-7.121,10.633 c-9.158,9.798-17.69,20.223-25.521,31.182c-4.832,6.761-9.573,15.578-5.946,23.103c9.882,20.506,27.955,9.839,22.761,39.163 c-6.536,36.735-54.777,51.752-27.219,95.636c10.085,16.06,28.427,25.666,46.92,26.533c13.269,0.623,29.608-6.487,29.778-20.227 c0.05-4.073-1.404-8.265-0.169-12.133c1.606-5.032,7.118-7.496,12.182-8.293c16.571-2.607,32.589,5.998,47.88,13.098 c4.616,2.143,10.127,4.139,14.516,1.536c14.298-8.479,7.626-15.474,27.066-17.348c16.577-1.597,35.974,11.623,45.363,24.695 c2.257,3.143,4.298,7.192,2.867,10.817c-1.243,3.151-4.68,4.772-6.415,7.664c-2.859,4.764,0.021,11.346,4.529,14.458 c4.508,3.112,10.115,3.797,15.424,4.928c24.906,5.304,25.489,29.865,43.089,42.122c14.289,9.952,50.686,11.915,47.474-16.71 c-1.174-10.463-11.329-19.071-9.664-29.463c1.466-9.148,11.403-14.017,20.295-15.181c8.892-1.164,18.381-0.294,26.331-4.577 c5.298-2.855,9.298-7.708,14.128-11.345c29.725-22.383,100.139-3.367,122.946,21.729c21.309,23.448,23.696,63.858,51.122,79.05 c-3.203-31.159-18.403-60.826-41.532-81.059c-4.253-3.721-8.932-7.359-11.164-12.639c-1.874-4.433-1.766-9.459-1.527-14.291 c1.216-24.68,5.897-47.661,12.408-70.699c-0.778,2.754,17.408-47.306,4.33-37.836c23.401-16.945,74.475-44.781,103.802-42.968 c15.272,0.944,30.346,10.081,36.758,24.451s2.544,33.475-10.08,42.415c-12.086,8.56-28.859,6.916-41.135,15.18 c-11.82,7.956-16.868,25.13-11.331,38.547c7.695-10.973,19.322-18.923,32.097-21.944c17.145-4.055,36.614,0.215,51.418-9.607 c10.922-7.246,16.657-21.091,16.79-34.513s-4.671-26.443-11.098-38.103c-4.649-8.434-10.245-16.512-12.732-25.874 c-3.989-15.012,0.735-31.353,9.133-44.272c31.223-48.036,89.017-68.798,142.485-51.135c3.559,1.176,7.357,2.752,9.208,6.11 c2.686,4.87,0.098,11.086,1.236,16.568c1.792,8.639,14.528,11.909,20.017,5.139c3.794-4.679,3.559-11.429,4.995-17.352 c3.735-15.402,18.906-24.825,33.657-29.217c18.032-5.369,66.482-30.152,71.461,2.615c0.436,2.869,0.346,5.897,1.548,8.521 c3.382,7.387,14.707,6.327,20.092,0.347c11.105-12.332,13.055-32.586,23.81-46.365c9.518-12.195,23.573-19.502,31.539-33.113 c19.74-33.728,4.705-77.81-29.636-94.145c-32.905-15.652-71.194-8.71-106.84-2.08c-24.539,4.564-108.818,22.058-114.818-19.067 c-0.492-3.371-0.385-6.962-1.962-9.955c-1.952-3.706-6.041-5.649-8.53-8.992c-3.177-4.268-3.306-10.097-5.019-15.185 c-6.218-18.477-29.649-21.864-48.56-22.092c1.907-11.46,2.942-25.421-5.965-32.514c-5.034-4.009-11.829-4.45-18.176-4.731 c-16.492-0.729-56.272,5.396-69.945-4.586c-18.111-13.222-5.637-35.746-13.53-53.982c-8.391-19.367-39.589-22.059-43.057-42.977 c-0.75-4.524,0.069-9.186-0.453-13.744c-1.274-11.118-10.029-19.495-18.218-26.814c-14.843-13.266-31.657-27.303-51.266-26.784 c-3.686,3.013-0.375,9.337,3.78,11.604c4.156,2.267,9.465,3.444,11.569,7.789c4.035,8.335-7.535,15.178-16.387,16.923 c-0.431,12.181,11.409,20.252,20.554,27.937c15.448,12.981,26.425,31.543,30.561,51.682c-31.166,5.79-63.099,7.147-94.619,4.021 c-37.979-3.766-62.375,58.595-107.391,41.309c-6.649-2.554-12.594-7.137-19.562-8.502c-17.524-3.433-31.64,13.741-47.389,22.401 c-23.978,13.185-53.375,6.348-79.073-2.731c-30.705-10.848-68.042-26.424-98.991-7.71c-11.567,6.996-20.806,17.88-33.053,23.503 c-25.704,11.802-54.867-2.688-82.86-5.467c-69.066-6.856-110.63,63.057-133.067,121.278c-3.405,8.836-6.459,18.119-6.014,27.62 c0.445,9.502,5.109,19.337,13.492,23.248c12.42,5.795,26.852-3.41,34.959-14.739c8.107-11.329,13.035-25.174,22.955-34.837 c9.919-9.663,28.147-12.772,35.981-1.24c3.855,5.674,4.012,13.101,4.026,20.036c0.027,13.171,0.054,26.343,0.081,39.514 c0.015,7.244-0.019,14.738-2.862,21.357c-4.748,11.053-16.078,17.154-26.602,22.424c-22.858,11.445-45.716,22.89-68.574,34.335 c-7.716,3.863-15.522,7.786-22.073,13.506c-29.859,26.071-9.795,62.154-32.83,87.256c-9.299,10.134-24.725,13.18-32.352,24.712 c-5.636,8.522-5.608,19.61-5.372,29.933C1740.128,2013.47,1747.289,2029.507,1757.613,2036.338z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098931321864087009490000005819731337411906742_",
    gradientUnits: "userSpaceOnUse",
    x1: 2454.4446,
    y1: 2386.9377,
    x2: 2801.3936,
    y2: 2386.9377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098931321864087009490000005819731337411906742_)"
    },
    d: "M2554.532,2255.407 c-9.255,17.311-7.976,39.939-28.893,49.497c-13.913,6.358-31.722,3.455-43.053,13.952c-12.927,11.975-9.551,33.212-7.053,50.975 c0.448,3.185,0.808,6.567-0.449,9.51c-3.331,7.795-15.273,7.589-19.369,14.984c-3.516,6.347,0.84,14.347,6.084,19.255 c15.975,14.951,41.939,16.91,59.842,4.514c4.764-3.298,9.925-7.706,15.492-6.293c6.494,1.649,8.673,9.807,10.437,16.48 c3.755,14.205,11.17,27.86,22.885,36.241c36.858,26.357,88.711-5.717,129.644,31.474c5.028,4.568,9.812,10,11.28,16.754 c1.586,7.298-0.785,15.681,3.181,21.936c4.967,7.833,17.19,6.771,23.874,0.451c6.684-6.32,9.368-15.838,12.159-24.75 s6.453-18.33,14.129-23.314c12.927-8.385,27.661-5.177,34.817-22.235c8.925-21.758-17.706-39.78-9.253-59.605 c3.774-8.852,9.808-18.512,6.02-27.358c-1.924-4.492-6.004-7.497-9.375-10.98c-15.776-16.314-18.459-31.664-39.478-41.615 c-13.411-6.349-41.199,1.866-46.706-21.276c-1.435-6.031,0.621-13.6-3.875-17.717c-2.548-2.333-6.275-2.492-9.678-2.48 c-23.52,0.085-51.491,0.45-64.896-19.543c-14.814-22.095-16.552-38.029-46.636-27.056 C2564.719,2241.201,2558.605,2247.789,2554.532,2255.407z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134247361331277708180000001280469519130940584_",
    gradientUnits: "userSpaceOnUse",
    x1: 1723.6633,
    y1: 2301.7834,
    x2: 2120.2004,
    y2: 2301.7834
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000134247361331277708180000001280469519130940584_)"
    },
    d: "M1853.463,2133.827 c-4.901,7.034-7.665,15.506-12.834,22.331c-14.545,19.203-20.86,2.227-37.298,8.693c-5.675,2.237-10.698,6.217-16.617,7.625 c-11.968,2.847-23.855-5.413-36.135-5.465c-47.301-0.198-22.472,78.467,0.428,93.552c4.238,2.792,9.583,2.831,14.607,2.78 c15.595-0.158,31.19-0.316,46.784-0.473c4.446-0.045,9.209,0.005,12.872,2.611c11.282,8.027,0.534,27.855,7.318,40.158 c4.655,8.441,15.472,10.011,24.722,11.747c19.55,3.67,23.828,25.68,35.796,39.257c15.383,17.453,30.061,24.49,38.733,49.827 c5.149,15.046,6.933,31.324,13.725,45.656c13.967,29.472,50.196,45.353,80.379,35.235 c30.183-10.118,50.524-44.962,45.128-77.307c-3.152-18.894-13.669-35.446-20.972-53.068 c-14.773-35.646-4.779-79.054,36.15-85.855c10.33-1.716,23.45-2.318,27.305-12.379c5.555-14.5-15.876-31.462-6.99-44.062 c3.198-4.536,9.39-6.159,12.202-10.962c3.778-6.455-0.521-14.811-5.785-20.035c-5.264-5.225-11.9-9.75-14.076-16.958 c-12.239-40.583-52.435-15.219-79.258-9.87c-23.924,4.771-37.568,1.67-57.472-10.234 C1931.354,2128.198,1884.652,2089.066,1853.463,2133.827z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057132201812430379880000014292278854445269675_",
    gradientUnits: "userSpaceOnUse",
    x1: 1943.8632,
    y1: 1509.509,
    x2: 2052.0415,
    y2: 1509.509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057132201812430379880000014292278854445269675_)"
    },
    d: "M1955.38,1499.204 c3.535-6.828,12.175-8.427,19.645-8.951c25.742-1.807,51.714-0.071,77.017,5.147c-20.946,17.039-44.329,34.95-70.961,34.023 c-12.081-0.421-24.618-4.729-35.92-0.293c-2.644-8.238-1.185-17.764,3.791-24.753L1955.38,1499.204z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003786088050199774200000008238394423851889552_",
    gradientUnits: "userSpaceOnUse",
    x1: 1651.0696,
    y1: 1794.1237,
    x2: 1744.7722,
    y2: 1794.1237
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003786088050199774200000008238394423851889552_)"
    },
    d: "M1657.751,1812.543 c26.268,21.508,118.93-7.191,75.701-34.95c-6.985-4.485-15.362-5.865-23.489-7.151c-10.923-1.729-22.126-3.453-32.947-1.134 c-10.821,2.319-21.356,9.566-24.603,20.494C1649.289,1800.315,1651.837,1807.701,1657.751,1812.543z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130613503848095365180000018395489258014510997_",
    gradientUnits: "userSpaceOnUse",
    x1: 2796.3521,
    y1: 1620.7684,
    x2: 2891.72,
    y2: 1620.7684
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130613503848095365180000018395489258014510997_)"
    },
    d: "M2802.214,1623.324 c16.249,14.738,39,18.363,60.412,21.381c10.687,1.506,24.68,1.098,28.371-9.387c3.892-11.057-8.67-21.267-19.977-22.548 c-11.307-1.281-23.318,1.81-33.792-2.777c-9.291-4.068-16.606-13.891-26.695-13.803c-11.745,0.103-18.855,17.834-10.629,26.507 L2802.214,1623.324z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008109001771106271820000007346188308538423715_",
    gradientUnits: "userSpaceOnUse",
    x1: 2968.9385,
    y1: 1577.4171,
    x2: 3006.3289,
    y2: 1128.73
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000008109001771106271820000007346188308538423715_)"
    },
    cx: 2844.61,
    cy: 3069.375,
    r: 201.79
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000141444554383813600170000003869978156324745117_",
    gradientUnits: "userSpaceOnUse",
    x1: 2908.9565,
    y1: 1565.6992,
    x2: 2946.6433,
    y2: 1113.4551
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4042E2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4F52FF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000141444554383813600170000003869978156324745117_)"
    },
    d: "M2904.976,3055.864h-133.403 c-14.697,0-26.61-11.914-26.61-26.61v-1230.72c0-14.696,11.914-26.61,26.61-26.61h133.403c14.697,0,26.61,11.914,26.61,26.61 v1230.72C2931.586,3043.95,2919.673,3055.864,2904.976,3055.864z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.66,
      fill: "#FFFFFF"
    },
    d: "M2881.1,3084.585h-83.215c-9.168,0-16.599-7.432-16.599-16.599V1843.608 c0-9.167,7.431-16.599,16.599-16.599h83.215c9.167,0,16.599,7.432,16.599,16.599v1224.378 C2897.699,3077.153,2890.267,3084.585,2881.1,3084.585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.66,
      fill: "#FFFFFF"
    },
    d: "M2912.017,2895.019V1862.06c0-41.272-32.614-74.73-73.886-74.73l0,0 c-41.272,0-73.886,33.458-73.886,74.73v1036.221c-63.811,29.28-103.992,91.833-103.992,164.29 c0,100.506,81.303,181.982,181.809,181.982c100.505,0,181.399-81.476,181.399-181.982 C3023.46,2987.303,2979.186,2922.714,2912.017,2895.019z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000118392110626648011080000011346862236260495774_",
    gradientUnits: "userSpaceOnUse",
    x1: 3044.875,
    y1: 1649.9587,
    x2: 3004.0852,
    y2: 1928.6879
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000118392110626648011080000011346862236260495774_)"
    },
    cx: 2839.492,
    cy: 3053.401,
    r: 163.734
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000093172633397012537790000012774928807661500803_",
    gradientUnits: "userSpaceOnUse",
    x1: 4517.0977,
    y1: 695.541,
    x2: 4105.2188,
    y2: 1287.1493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000093172633397012537790000012774928807661500803_)"
    },
    d: "M3068.257,2878.313h-118.557 c-2.598,0-4.723-2.125-4.723-4.722v-23.676c0-2.597,2.125-4.723,4.723-4.723h118.557c2.598,0,4.723,2.125,4.723,4.723v23.676 C3072.979,2876.188,3070.854,2878.313,3068.257,2878.313z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175311672611571158550000011318491331778640262_",
    gradientUnits: "userSpaceOnUse",
    x1: 4360.5063,
    y1: 617.3128,
    x2: 3948.6277,
    y2: 1208.921
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000175311672611571158550000011318491331778640262_)"
    },
    d: "M3068.257,2575.162h-118.557 c-2.598,0-4.723-2.125-4.723-4.723v-23.676c0-2.598,2.125-4.723,4.723-4.723h118.557c2.598,0,4.723,2.125,4.723,4.723v23.676 C3072.979,2573.037,3070.854,2575.162,3068.257,2575.162z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000154420991069797756320000016582966390136000445_",
    gradientUnits: "userSpaceOnUse",
    x1: 4512.1484,
    y1: 598.1904,
    x2: 4087.1501,
    y2: 1208.6434
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000154420991069797756320000016582966390136000445_)"
    },
    d: "M3028.847,2802.157h-79.148 c-2.598,0-4.723-2.125-4.723-4.723v-23.676c0-2.597,2.125-4.723,4.723-4.723h79.148c2.597,0,4.723,2.125,4.723,4.723v23.676 C3033.57,2800.032,3031.444,2802.157,3028.847,2802.157z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155146592842348500810000018101117218005072036_",
    gradientUnits: "userSpaceOnUse",
    x1: 4471.2432,
    y1: 580.1989,
    x2: 4046.2446,
    y2: 1190.6519
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155146592842348500810000018101117218005072036_)"
    },
    d: "M3028.847,2725.41h-79.148 c-2.598,0-4.723-2.125-4.723-4.723v-23.676c0-2.597,2.125-4.722,4.723-4.722h79.148c2.597,0,4.723,2.125,4.723,4.723v23.676 C3033.57,2723.285,3031.444,2725.41,3028.847,2725.41z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101802933565174955580000000279965426364992181_",
    gradientUnits: "userSpaceOnUse",
    x1: 4430.5493,
    y1: 562.2969,
    x2: 4005.5508,
    y2: 1172.7499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101802933565174955580000000279965426364992181_)"
    },
    d: "M3028.847,2649.057h-79.148 c-2.598,0-4.723-2.125-4.723-4.723v-23.676c0-2.597,2.125-4.723,4.723-4.723h79.148c2.597,0,4.723,2.125,4.723,4.723v23.676 C3033.57,2646.931,3031.444,2649.057,3028.847,2649.057z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124849103001409910340000014483762478857627545_",
    gradientUnits: "userSpaceOnUse",
    x1: 4197.6563,
    y1: 536.183,
    x2: 3785.7776,
    y2: 1127.7911
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124849103001409910340000014483762478857627545_)"
    },
    d: "M3069.417,2258.454h-118.558 c-2.597,0-4.723-2.125-4.723-4.723v-23.676c0-2.597,2.125-4.723,4.723-4.723h118.558c2.597,0,4.723,2.125,4.723,4.723v23.676 C3074.139,2256.329,3072.014,2258.454,3069.417,2258.454z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116209690539661523690000016287571383809256620_",
    gradientUnits: "userSpaceOnUse",
    x1: 4344.0718,
    y1: 524.5677,
    x2: 3919.0737,
    y2: 1135.0204
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116209690539661523690000016287571383809256620_)"
    },
    d: "M3030.007,2485.449h-79.148 c-2.597,0-4.723-2.125-4.723-4.723v-23.676c0-2.598,2.125-4.723,4.723-4.723h79.148c2.598,0,4.723,2.125,4.723,4.723v23.676 C3034.729,2483.323,3032.604,2485.449,3030.007,2485.449z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000072966779320013696430000001527431968673379514_",
    gradientUnits: "userSpaceOnUse",
    x1: 4303.1665,
    y1: 506.576,
    x2: 3878.1682,
    y2: 1117.0286
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000072966779320013696430000001527431968673379514_)"
    },
    d: "M3030.007,2408.702h-79.148 c-2.597,0-4.723-2.125-4.723-4.723v-23.676c0-2.597,2.125-4.722,4.723-4.722h79.148c2.598,0,4.723,2.125,4.723,4.722v23.676 C3034.729,2406.576,3032.604,2408.702,3030.007,2408.702z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000116198571150884087900000010621326703344099474_",
    gradientUnits: "userSpaceOnUse",
    x1: 4262.4727,
    y1: 488.6739,
    x2: 3837.4744,
    y2: 1099.1266
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000116198571150884087900000010621326703344099474_)"
    },
    d: "M3030.007,2332.348h-79.148 c-2.597,0-4.723-2.125-4.723-4.723v-23.676c0-2.597,2.125-4.723,4.723-4.723h79.148c2.598,0,4.723,2.125,4.723,4.723v23.676 C3034.729,2330.223,3032.604,2332.348,3030.007,2332.348z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106865230643234369550000000685338684023848610_",
    gradientUnits: "userSpaceOnUse",
    x1: 4035.3188,
    y1: 455.0811,
    x2: 3623.4402,
    y2: 1046.6891
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106865230643234369550000000685338684023848610_)"
    },
    d: "M3069.417,1944.176h-118.558 c-2.597,0-4.723-2.125-4.723-4.723v-23.676c0-2.598,2.125-4.723,4.723-4.723h118.558c2.597,0,4.723,2.125,4.723,4.723v23.676 C3074.139,1942.051,3072.014,1944.176,3069.417,1944.176z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034079165782695570230000006150062617672027023_",
    gradientUnits: "userSpaceOnUse",
    x1: 4176.5679,
    y1: 450.8872,
    x2: 3751.5696,
    y2: 1061.3398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034079165782695570230000006150062617672027023_)"
    },
    d: "M3030.007,2171.171h-79.148 c-2.597,0-4.723-2.125-4.723-4.722v-23.676c0-2.597,2.125-4.723,4.723-4.723h79.148c2.598,0,4.723,2.125,4.723,4.723v23.676 C3034.729,2169.046,3032.604,2171.171,3030.007,2171.171z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080191530820025157280000017605845203990026667_",
    gradientUnits: "userSpaceOnUse",
    x1: 4135.6621,
    y1: 432.8956,
    x2: 3710.6641,
    y2: 1043.3483
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080191530820025157280000017605845203990026667_)"
    },
    d: "M3030.007,2094.424h-79.148 c-2.597,0-4.723-2.125-4.723-4.723v-23.676c0-2.597,2.125-4.723,4.723-4.723h79.148c2.598,0,4.723,2.125,4.723,4.723v23.676 C3034.729,2092.299,3032.604,2094.424,3030.007,2094.424z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070802894159723308100000018422787595770835847_",
    gradientUnits: "userSpaceOnUse",
    x1: 4094.9641,
    y1: 414.9996,
    x2: 3669.9658,
    y2: 1025.4523
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000070802894159723308100000018422787595770835847_)"
    },
    d: "M3030.007,2018.071h-79.148 c-2.597,0-4.723-2.125-4.723-4.723v-23.676c0-2.597,2.125-4.723,4.723-4.723h79.148c2.598,0,4.723,2.125,4.723,4.723v23.676 C3034.729,2015.946,3032.604,2018.071,3030.007,2018.071z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000023991286834922848170000009367744796792971965_",
    gradientUnits: "userSpaceOnUse",
    x1: 3404.4641,
    y1: 813.2687,
    x2: 3234.5078,
    y2: 1227.9618
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000023991286834922848170000009367744796792971965_)"
    },
    d: "M2903.455,2352.874v-324.92 c0-23.872-22.716-42.187-46.587-42.187h-42.924c-16.715,0-29.458,12.513-29.458,29.229v337.878H2903.455z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047746554611563435940000007612914594577990790_",
    gradientUnits: "userSpaceOnUse",
    x1: 2373.5674,
    y1: 2457.7102,
    x2: 3559.292,
    y2: 2828.2485
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FE7062"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000047746554611563435940000007612914594577990790_)"
    },
    d: "M2784.485,2189.716v812.561 c0,13.629,10.242,23.627,23.871,23.627h67.056c13.631,0,28.042-9.998,28.042-23.627v-812.561H2784.485z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016788616137780051320000009142010453069538716_",
    gradientUnits: "userSpaceOnUse",
    x1: 3009.8364,
    y1: 1644.8295,
    x2: 2969.0466,
    y2: 1923.5586
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016788616137780051320000009142010453069538716_)"
    },
    d: "M2784.485,2505.835v543.459 c0,13.629,10.242,20.797,23.871,20.797h67.056c13.631,0,28.042-7.168,28.042-20.797v-543.459H2784.485z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150062368279001019060000006264487349824569505_",
    gradientUnits: "userSpaceOnUse",
    x1: 1386.1475,
    y1: 3098.7085,
    x2: 850.928,
    y2: 3680.8777,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150062368279001019060000006264487349824569505_)"
    },
    d: "M988.993,3142.077 c0,0-5.543,31.379-8.26,62.441c-1.062,12.139,8.297,22.68,20.473,23.188c41.365,1.723,129.848,5.073,161.598,3.655 c4.773-0.213,7.894-5.099,6.127-9.539l0,0c-1.48-3.719-4.335-6.727-7.973-8.399l-146.156-67.173L988.993,3142.077z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000015348470392232026680000001191497765614137243_",
    gradientUnits: "userSpaceOnUse",
    x1: 1212.4232,
    y1: 3141.9475,
    x2: 1259.9637,
    y2: 3141.9475,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000015348470392232026680000001191497765614137243_)"
    },
    d: "M984.453,3123.64l4.453,37.533 c0,0,25.603,11.919,43.087-1.502l-10.603-41.828L984.453,3123.64z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000126298800007592432270000002402508880374144652_",
    gradientUnits: "userSpaceOnUse",
    x1: 1428.2903,
    y1: 2440.3374,
    x2: 972.8696,
    y2: 3057.6013,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000126298800007592432270000002402508880374144652_)"
    },
    d: "M987.799,2417.996 c-1.923,9.802-10.325,489.126,40.912,703.929c0.836,3.505-0.941,7.118-4.277,8.481c-7.859,3.21-23.264,7.86-41.727,8.48 c-5.718,0.192-10.844-3.524-12.457-9.013c-14.645-49.837-84.826-299.537-93.98-538.067c-10.23-266.535,0-9.075,0-9.075 l5.999-164.755L987.799,2417.996z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124873710806332441140000010629194399830374034_",
    gradientUnits: "userSpaceOnUse",
    x1: 1266.08,
    y1: 2988.3232,
    x2: 730.8589,
    y2: 3570.4941,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124873710806332441140000010629194399830374034_)"
    },
    d: "M820.865,3158.447 c0,0-8.823,15.841-17.365,57.935c-1.542,7.603,3.769,14.878,11.489,15.637c13.659,1.343,34.687,3.07,51.53,2.954 c7.764-0.053,13.824-6.814,12.888-14.522c-1.866-15.365-7.678-40.574-25.634-60.221L820.865,3158.447z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003069470006289216710000012159821622867039390_",
    gradientUnits: "userSpaceOnUse",
    x1: 1041.0864,
    y1: 3139.5095,
    x2: 1082.1335,
    y2: 3139.5095,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003069470006289216710000012159821622867039390_)"
    },
    d: "M813.116,3110.17l10.405,56.76 c0,0,10.289,7.653,30.642,2.105l-4.967-61.071L813.116,3110.17z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085952839441026311730000016625395492180891814_",
    gradientUnits: "userSpaceOnUse",
    x1: 1347.1234,
    y1: 2380.4517,
    x2: 891.7029,
    y2: 2997.7156,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085952839441026311730000016625395492180891814_)"
    },
    d: "M785.005,2432.705 c-41.905,252.896,9.09,625.053,26.288,697.893c1.053,4.46,4.652,7.876,9.172,8.625c7.677,1.273,20.315,2.311,32.775-1.307 c4.293-1.247,7.309-5.119,7.485-9.587c2.307-58.89-1.846-420.41,37.2-563.286c1.979-7.241,6.4-13.555,12.518-17.905 l75.784-53.876l5.81-87.086L785.005,2432.705z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040574075341702509610000005598770535996916671_",
    gradientUnits: "userSpaceOnUse",
    x1: 1220.7902,
    y1: 1450.4492,
    x2: 1163.0048,
    y2: 1583.0155
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000040574075341702509610000005598770535996916671_)"
    },
    d: "M1079.458,2093.032 c0,0-0.204,0.136-0.375,0.409l-1.576,0.068c-0.17,0.238-1.882,0.646-1.882,1.124v0.033l1.508,0.511 c0,0.51,0.703,1.158,0.567,1.873l0.352,0.306c-1.77,10.485-11.382,39.184-21.901,76.325c-0.102,0.307-0.074,0.647-0.176,0.954 c-23.592,83.338-57.656,208.773-67.937,266.852c0,0-18.199,9.028-46.523,13.501h-0.068c-40.92,8.947-102.675,17.138-160.14,2.091 c0,0-30.877-252.05,6.536-470.473c0,0,98.147-24.473,204.09-31.146c0.545-0.034,1.089,1.861,1.634,1.827 c8.545-0.477,17.124,1.147,25.703,1.147h6.809c0.953,0,1.872,0,2.826,0h0.17c4.392,0,12.324,1.545,21.584,5.459 c0.272,0.102,0.817-0.862,0.817-0.725c0,0,0.068-0.806,0.102-0.806c0,0,1.6,0.716,2.315,1.023 c1.055,0.442,2.145,0.89,3.268,1.435c0.238,0.136,0.511,0.241,0.749,0.343c0.102,0.068,0.238,0.086,0.34,0.154 c0.715,0.375,1.464,0.742,2.247,1.116c0.17,0.068,0.306,0.132,0.443,0.201c0.885,0.442,1.77,0.917,2.689,1.393 c0.136,0.069-0.579,0.135-0.443,0.238c1.055,0.544,2.417,1.124,3.506,1.702c0.987,0.51,1.736,1.055,1.804,1.633l0.136-0.885 c0.51,0.272,1.055,0.578,1.566,0.885c0,0,0.102,0.034,0.136,0.068c5.651,3.302,11.336,7.149,16.613,11.643 c0.034,0.034,0.034,0.068,0.068,0.102c0.068,0.102,0.17,0.239,0.238,0.341 C1110.982,2023.175,1122.012,2087.756,1079.458,2093.032z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182526365280846355910000012388689629608596875_",
    gradientUnits: "userSpaceOnUse",
    x1: 1416.265,
    y1: 1535.6575,
    x2: 1358.4796,
    y2: 1668.2238
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182526365280846355910000012388689629608596875_)"
    },
    d: "M1327.382,2158.367 c-106.777-11.299-156.9-93.558-196.586-145.87c-52.396-69.066-108.615-52.549-108.615-52.549l33.776,147.811 c79.222,126.237,192.539,132.239,268.713,117.81C1332.448,2199.935,1331.163,2176.455,1327.382,2158.367z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000044897338188982012990000005827928689140118186_",
    gradientUnits: "userSpaceOnUse",
    x1: 1634.276,
    y1: 1630.6857,
    x2: 1576.4905,
    y2: 1763.2522
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000044897338188982012990000005827928689140118186_)"
    },
    d: "M1487.763,2134.608l-38.849,9.479 c-47.342,14.259-87.335,17.899-121.533,14.28c3.781,18.088,5.066,41.569-2.712,67.203c48.49-9.184,81.933-26.645,81.933-26.645 C1495.776,2172.961,1487.763,2134.608,1487.763,2134.608z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000029015101375316697120000014718612676734298021_",
    gradientUnits: "userSpaceOnUse",
    x1: 943.1911,
    y1: 1643.6886,
    x2: 455.5398,
    y2: 2267.5957,
    gradientTransform: "matrix(0.9678 0.2516 -0.2516 0.9678 1190.7006 216.9008)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000029015101375316697120000014718612676734298021_)"
    },
    d: "M1575.677,2208.736 c-0.299-7.886-4.168-15.209-10.514-19.901l-61.933-45.796c0,0,1.262-9.142,18.487-11.099 c17.226-1.956,18.124-20.445,18.124-20.445s-23.928,4.196-59.27,11.531c-20.21,4.195-34.323,17.21-42.71,27.588l11.717,28.044 c39.299,23.889,81.797,37.552,126.62,43.783L1575.677,2208.736z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099640089195979913160000007970688892349215624_",
    gradientUnits: "userSpaceOnUse",
    x1: 1256.7719,
    y1: 1954.4923,
    x2: 1258.0996,
    y2: 1954.4923,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099640089195979913160000007970688892349215624_)"
    },
    d: "M1030.129,1954.543 c-0.375-0.034-0.715-0.034-1.055-0.034c-0.102-0.034-0.17-0.034-0.272-0.068L1030.129,1954.543z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170987449773693232970000017119432230698865325_",
    gradientUnits: "userSpaceOnUse",
    x1: 1276.6738,
    y1: 1953.3923,
    x2: 1276.5697,
    y2: 1953.5541,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53EAC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170987449773693232970000017119432230698865325_)"
    },
    d: "M1048.784,1953.216c0,0,0,0.033,0,0.102 C1048.784,1953.249,1048.784,1953.216,1048.784,1953.216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000031175932490176780280000013658737391214888102_",
    gradientUnits: "userSpaceOnUse",
    x1: 1279.3579,
    y1: 1953.5924,
    x2: 1279.198,
    y2: 1953.8407,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53EAC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031175932490176780280000013658737391214888102_)"
    },
    d: "M1051.611,1953.386l-0.136,0.068v-0.136 C1051.509,1953.353,1051.543,1953.386,1051.611,1953.386z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147918892855559428400000005378467956611225768_",
    gradientUnits: "userSpaceOnUse",
    x1: 1069.6292,
    y1: 1384.558,
    x2: 1011.8437,
    y2: 1517.1244
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147918892855559428400000005378467956611225768_)"
    },
    d: "M836.046,2108.087l-48.167-121.598 c0,0-117.298,79.699-136.589,180.749c22.163,1.633,62.494,7.397,101.97,27.33 C761.935,2146.854,836.046,2108.087,836.046,2108.087z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000129893928022301540930000000340571837350895033_",
    gradientUnits: "userSpaceOnUse",
    x1: 1214.4244,
    y1: 2141.0618,
    x2: 1435.7012,
    y2: 1981.8163,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9CFFFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9BFFFA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000129893928022301540930000000340571837350895033_)"
    },
    points: "995.103,2105.715 995.103,2122.652 1057.731,2118.889 1057.731,2100.069  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059268177075352518760000001080102155902101433_",
    gradientUnits: "userSpaceOnUse",
    x1: 1147.6886,
    y1: 1418.5835,
    x2: 1089.9031,
    y2: 1551.1499
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059268177075352518760000001080102155902101433_)"
    },
    d: "M938.697,2218.945 c0,0-131.696,74.429-176.133,10.875c-9.226-13.196-11.432-26.311-9.159-38.814c-39.476-19.932-79.807-25.698-101.97-27.329 c-5.816,30.463-2.741,62.862,15.16,95.608c77.838,142.387,289.53-7.869,289.53-7.869L938.697,2218.945z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016797418445838873220000004307473896573766553_",
    gradientUnits: "userSpaceOnUse",
    x1: 1277.0853,
    y1: 2023.6078,
    x2: 1446.0936,
    y2: 2727.811,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016797418445838873220000004307473896573766553_)"
    },
    d: "M922.874,2313.105l71.875-251.004 c0.816-2.849,3.246-4.928,6.19-5.271c13.023-1.519,50.756-5.785,94.325-9.47c52.479-4.439,113.423-8.036,149.841-4.976 c5.177,0.434,8.306,5.911,6.004,10.569c-20.71,41.898-105.896,212.328-148.554,268.159c-1.413,1.85-3.599,2.931-5.926,2.909 l-166.763-1.552C925.013,2322.426,921.539,2317.771,922.874,2313.105z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1102.719,2025.6l52.111-8.683c2.776-0.462,5.048,2.19,4.167,4.861l-5.159,15.632 c-0.449,1.36-1.636,2.345-3.057,2.535l-50.146,6.698c-2.594,0.346-4.733-2.011-4.137-4.559l3.193-13.648 C1100.036,2026.967,1101.23,2025.848,1102.719,2025.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#91B3FA"
    },
    d: "M1063.7,2069.716l4.293-22.361c0.43-2.243,2.282-3.938,4.554-4.168l105.251-10.681 c3.543-0.359,6.38,2.888,5.548,6.35l-6.693,27.864c-0.535,2.229-2.475,3.839-4.766,3.955l-102.852,5.177 C1065.689,2076.021,1063.068,2073.008,1063.7,2069.716z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000153687264789861237510000002867127219438542745_",
    gradientUnits: "userSpaceOnUse",
    x1: 1161.2759,
    y1: 2209.9067,
    x2: 1257.0323,
    y2: 2209.9067,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000153687264789861237510000002867127219438542745_)"
    },
    d: "M940.239,2252.463 c0,0-10.012-41.17-5.974-55.777c4.039-14.606,11.864-33.385,37.947-29.213c26.083,4.173,56.85,15.161,56.85,15.161 s-1.554,19.026-21.377,12.887l12.292,9.512c0,0-1.757,15.233-18.501,7.095l11.433,12.615c0,0-7.191,12.511-19.51,4.487 C981.08,2221.205,975.175,2257.421,940.239,2252.463z"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050632660714845875040000005549610472776289707_",
    gradientUnits: "userSpaceOnUse",
    x1: 890.921,
    y1: 2091.2849,
    x2: 835.5262,
    y2: 2324.1956
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000050632660714845875040000005549610472776289707_)"
    },
    d: "M814.724,2255.9 c-12.236,0-23.466-1.809-32.014-6.5c-0.824-0.454-1.125-1.488-0.673-2.312c0.452-0.823,1.488-1.122,2.312-0.673 c35.092,19.266,121.71-13.72,122.581-14.058c0.233-0.08,17.07-5.928,23.082-17.668c0.429-0.834,1.45-1.167,2.291-0.738 c0.836,0.427,1.167,1.453,0.738,2.291c-6.646,12.979-24.208,19.065-24.952,19.317 C905.372,2236.606,854.694,2255.9,814.724,2255.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000113347123122632553190000001179064306602381226_",
    gradientUnits: "userSpaceOnUse",
    x1: 1150.5137,
    y1: 1981.8358,
    x2: 988.1053,
    y2: 2650.3535,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000113347123122632553190000001179064306602381226_)"
    },
    d: "M767.225,2320.783 c-0.913,0-1.667-0.009-1.699-0.928c-0.033-0.939,0.703-1.369,1.642-1.401c100.016-3.444,156.945-49.05,157.509-49.512 c0.726-0.6,1.799-0.399,2.395,0.327c0.595,0.726,0.49,1.128-0.238,1.725c-0.572,0.469-58.394,49.788-159.55,49.788H767.225z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112615496407533061630000006764896333451377338_",
    gradientUnits: "userSpaceOnUse",
    x1: 1276.6738,
    y1: 1953.3923,
    x2: 1276.5697,
    y2: 1953.5541,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53EAC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#45AED8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112615496407533061630000006764896333451377338_)"
    },
    d: "M1048.784,1953.216c0,0,0,0.033,0,0.102 C1048.784,1953.249,1048.784,1953.216,1048.784,1953.216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091705107716096854240000016817574913126645407_",
    gradientUnits: "userSpaceOnUse",
    x1: 1083.8473,
    y1: 2007.337,
    x2: 1129.1707,
    y2: 1997.58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#53D8FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3840F7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091705107716096854240000016817574913126645407_)"
    },
    d: "M848.127,1973.797l114.252,144.153 l74.91-159.26C976.652,1952.387,914.277,1958.068,848.127,1973.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86,
      fill: "#FFFFFF"
    },
    d: "M848.127,1973.797l114.252,144.153l75.854-159.261 C977.595,1952.386,914.277,1958.068,848.127,1973.797z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106844730366324343760000000385770005724340621_",
    gradientUnits: "userSpaceOnUse",
    x1: 991.2137,
    y1: 2009.8837,
    x2: 1048.7535,
    y2: 1979.4214,
    gradientTransform: "matrix(1 0 0 1 -227.9703 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106844730366324343760000000385770005724340621_)"
    },
    d: "M924.82,1851.565l-39.958,115.555 c-0.661,1.914,2.094,0.662,3.868,1.642c10.892,6.022,44.064,15.423,95.454-3.182c5.484-1.985,8.28-8.217,9.028-14.002 l12.939-100.012H924.82z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000182500709125676313030000001713172825876501932_",
    gradientUnits: "userSpaceOnUse",
    x1: -2767.561,
    y1: 1663.8306,
    x2: -2933.4155,
    y2: 1790.7346,
    gradientTransform: "matrix(0.9899 0.1417 -0.1417 0.9899 4003.4033 546.1045)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000182500709125676313030000001713172825876501932_)"
    },
    d: "M1030.32,1742.031 c0,0,19.278,70.084,16.251,104.989c-3.027,34.904,1.219,58.441-39.818,59.684c-41.036,1.243-71.911-23.53-85.248-60.638 c0,0-21.024-57.248-11.486-78.095C919.557,1747.123,1030.32,1742.031,1030.32,1742.031z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155840734114743011350000007880847622591996032_",
    gradientUnits: "userSpaceOnUse",
    x1: -398.5926,
    y1: 1486.9027,
    x2: -95.9536,
    y2: 1876.5498,
    gradientTransform: "matrix(-0.9899 -0.1417 -0.1417 0.9899 901.6152 101.783)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000155840734114743011350000007880847622591996032_)"
    },
    d: "M866.784,1745.927 c8.739-5.442,14.426-3.564,17.755-0.819c0.938,0.772,2.089,0.795,3.017,0.341c0.091-1.035,6.725-72.673,104.38-60.071 c10.145,1.309,20.085-3.651,25.137-12.546c11.549-20.334,33.45-50.229,49.991-21.019 c23.528,41.551,30.507,96.073-36.133,107.375c-3.942,0.669-7.922,1.201-11.917,1.628c-27.511,6.785-58.846,8.92-70.459,11.849 c-19.4,4.892-4.577,50.028-4.577,50.028l-5.062-0.724l-10.789-1.544c-1.568-0.224-3.09,1.547-3.217,3.126l-0.929,30.959 c-0.107,1.331-2.734,2.41-4.061,2.554c-4.931,0.536-17.726,0.053-37.397-14.382c-19.23-14.111-10.006-21.273-4.113-24.011 c1.673-0.777,1.997-2.962,0.75-4.321C852.906,1785.755,851.587,1755.392,866.784,1745.927z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079458507265869202860000015570987114276603283_",
    gradientUnits: "userSpaceOnUse",
    x1: -2788.1335,
    y1: 1636.9452,
    x2: -2953.9888,
    y2: 1763.8497,
    gradientTransform: "matrix(0.9899 0.1417 -0.1417 0.9899 4003.4033 546.1045)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FEBBBA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF928E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000079458507265869202860000015570987114276603283_)"
    },
    d: "M939.075,1829.732 c0,0-4.925-43.712-25.511-34.6c-20.586,9.112,3.047,48.623,18.012,52.375L939.075,1829.732z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M1048.231,1745.966c-0.333-0.048-0.647-0.219-0.874-0.503c-0.465-0.587-0.365-1.44,0.225-1.909 c14.034-11.101,21.745-23.94,22.913-38.156c2.034-24.721-16.581-45.521-16.768-45.728c-0.505-0.557-0.465-1.415,0.09-1.92 c0.56-0.506,1.42-0.464,1.92,0.09c0.801,0.881,19.588,21.849,17.469,47.758c-1.228,15.007-9.283,28.492-23.94,40.087 C1048.964,1745.929,1048.586,1746.017,1048.231,1745.966z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M890.972,1942.037c-6.13,8.663-7.04,10.27-15.463,25.15c21.717,12.275,53.286,14.651,80.26,9.443 c-20.496-10.785-43.754-22.194-59.241-35.349C894.835,1939.844,892.256,1940.224,890.972,1942.037z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M955.77,1976.63c17.857-14.905,33.2-25.062,39.343-38.084c8.966,5.274,12.409,9.002,22.175,15.441 c2.437,1.606,1.868,5.33-0.947,6.099L955.77,1976.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000165946386194458709090000002640789055326898111_",
    gradientUnits: "userSpaceOnUse",
    x1: 938.9394,
    y1: 1974.1852,
    x2: 970.0161,
    y2: 1974.1852
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000165946386194458709090000002640789055326898111_)"
    },
    d: "M967.211,1963.336l-25.809,1.688 c-1.941,0.127-3.078,2.243-2.113,3.931l8.433,14.759c0.495,0.866,1.437,1.378,2.434,1.322l13.157-0.745 c1.133-0.064,2.098-0.848,2.393-1.945l4.219-15.702C970.392,1964.903,969.01,1963.218,967.211,1963.336z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035511414731204627570000004081683240247190178_",
    gradientUnits: "userSpaceOnUse",
    x1: 930.2755,
    y1: 2051.0674,
    x2: 990.0776,
    y2: 2051.0674
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#09005D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A0F91"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000035511414731204627570000004081683240247190178_)"
    },
    d: "M948.531,1985.129 c-1.629,25.236-9.007,57.982-18.256,93.164l32.104,39.658l27.698-58.227c-8.631-30.44-17.195-59.87-24.865-75.539 L948.531,1985.129z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000065764500166945181960000002762870765929521792_",
    gradientUnits: "userSpaceOnUse",
    x1: 2128.2725,
    y1: 2074.6362,
    x2: 1812.5762,
    y2: 3172.8582
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000065764500166945181960000002762870765929521792_)"
    },
    d: "M1976.302,2221.118 c49.438-44.919,126.233-38.113,171.645,12.4c44.004,48.948,44.004,123.155,0,168.354 c-45.412,46.645-122.207,46.906-171.645-2.225C1925.186,2348.849,1925.186,2267.562,1976.302,2221.118z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2095.834,2314.704c0,19.858-14.922,35.806-33.383,35.621 c-18.521-0.186-33.58-16.531-33.58-36.506c0-19.975,15.059-35.922,33.58-35.618 C2080.912,2278.503,2095.834,2294.846,2095.834,2314.704z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2091.025,2272.283c-1.561,2.949-5.063,3.937-7.821,2.205l0,0 c-2.76-1.733-3.73-5.532-2.167-8.483l9.699-18.302c1.561-2.945,5.058-3.923,7.811-2.185l0,0 c2.751,1.737,3.718,5.53,2.16,8.474L2091.025,2272.283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2033.401,2381.15c-1.577,2.979-5.114,4.006-7.901,2.291l0,0 c-2.788-1.715-3.768-5.524-2.189-8.505l9.798-18.489c1.577-2.975,5.11-3.991,7.89-2.271l0,0 c2.779,1.719,3.756,5.523,2.182,8.496L2033.401,2381.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2126.561,2355.427c-1.551,2.952-5.031,3.962-7.772,2.255l-17.049-10.615 c-2.751-1.713-3.718-5.499-2.159-8.455l0,0c1.558-2.956,5.05-3.96,7.799-2.246l17.032,10.625 C2127.15,2348.7,2128.112,2352.476,2126.561,2355.427L2126.561,2355.427z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2025.078,2292.179c-1.579,2.969-5.121,3.969-7.912,2.231l-17.356-10.806 c-2.801-1.744-3.785-5.569-2.198-8.543l0,0c1.586-2.973,5.141-3.967,7.939-2.222l17.339,10.817 C2025.677,2285.396,2026.657,2289.211,2025.078,2292.179L2025.078,2292.179z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2033.359,2271.596c1.602,3.001,5.144,4.076,7.91,2.401l0,0 c2.764-1.674,3.708-5.461,2.109-8.461l-9.939-18.641c-1.603-3.006-5.148-4.091-7.92-2.422l0,0 c-2.773,1.67-3.721,5.463-2.115,8.47L2033.359,2271.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2091.915,2381.292c1.586,2.971,5.091,4.006,7.829,2.313l0,0 c2.736-1.692,3.67-5.469,2.087-8.438l-9.837-18.45c-1.586-2.975-5.096-4.021-7.84-2.334l0,0 c-2.745,1.688-3.683,5.47-2.094,8.447L2091.915,2381.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1997.955,2354.83c1.612,2.999,5.176,4.051,7.959,2.351l17.246-10.535 c2.773-1.694,3.72-5.493,2.116-8.488l0,0c-1.605-2.995-5.156-4.052-7.932-2.36l-17.264,10.524 C1997.294,2348.021,1996.342,2351.83,1997.955,2354.83L1997.955,2354.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2099.386,2292.937c1.584,2.981,5.084,4.043,7.819,2.373l16.943-10.349 c2.724-1.664,3.655-5.425,2.078-8.401l0,0c-1.577-2.977-5.065-4.044-7.792-2.382l-16.96,10.338 C2098.737,2286.184,2097.802,2289.955,2099.386,2292.937L2099.386,2292.937z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2057.046,2261.907c0.03,3.43,2.636,6.229,5.819,6.252l0,0 c3.182,0.023,5.736-2.737,5.706-6.164l-0.185-21.274c-0.03-3.427-2.632-6.231-5.814-6.263l0,0 c-3.184-0.032-5.741,2.722-5.712,6.153L2057.046,2261.907z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2058.143,2387.891c0.03,3.43,2.636,6.2,5.819,6.188l0,0c3.181-0.012,5.734-2.8,5.704-6.226 l-0.185-21.27c-0.03-3.426-2.632-6.201-5.813-6.198l0,0c-3.183,0.003-5.74,2.786-5.71,6.215L2058.143,2387.891z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1987.871,2314.931c0.03,3.451,2.668,6.255,5.89,6.263l19.963,0.05 c3.209,0.008,5.785-2.775,5.755-6.217l0,0c-0.03-3.442-2.655-6.241-5.864-6.252l-19.963-0.072 C1990.43,2308.692,1987.841,2311.48,1987.871,2314.931L1987.871,2314.931z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2105.101,2315.287c0.03,3.416,2.614,6.191,5.771,6.199l19.557,0.049 c3.144,0.008,5.668-2.747,5.638-6.154l0,0c-0.03-3.406-2.601-6.177-5.745-6.188l-19.558-0.07 C2107.608,2309.112,2105.072,2311.872,2105.101,2315.287L2105.101,2315.287z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158013072825768134350000017375762953804438192_",
    gradientUnits: "userSpaceOnUse",
    x1: 1262.8638,
    y1: 1155.0398,
    x2: 947.1673,
    y2: 2253.2617
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FE7062"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158013072825768134350000017375762953804438192_)"
    },
    d: "M1110.893,1301.522 c49.438-44.919,126.233-38.113,171.645,12.4c44.004,48.948,44.004,123.155,0,168.354 c-45.412,46.645-122.207,46.906-171.645-2.225C1059.777,1429.253,1059.777,1347.965,1110.893,1301.522z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1230.426,1395.107c0,19.858-14.922,35.807-33.383,35.621 c-18.521-0.186-33.58-16.531-33.58-36.506s15.059-35.922,33.58-35.618C1215.504,1358.906,1230.426,1375.249,1230.426,1395.107z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1225.616,1352.686c-1.561,2.949-5.062,3.937-7.821,2.205l0,0 c-2.76-1.733-3.73-5.532-2.167-8.483l9.699-18.302c1.561-2.945,5.058-3.923,7.811-2.185l0,0 c2.751,1.737,3.718,5.53,2.16,8.474L1225.616,1352.686z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1167.992,1461.554c-1.577,2.979-5.114,4.006-7.901,2.291l0,0 c-2.788-1.715-3.768-5.524-2.189-8.505l9.798-18.489c1.577-2.975,5.11-3.991,7.89-2.271l0,0 c2.779,1.719,3.756,5.522,2.182,8.496L1167.992,1461.554z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1261.153,1435.83c-1.551,2.952-5.031,3.962-7.772,2.255l-17.049-10.615 c-2.751-1.713-3.718-5.499-2.16-8.455l0,0c1.558-2.955,5.05-3.96,7.799-2.246l17.032,10.625 C1261.741,1429.104,1262.704,1432.88,1261.153,1435.83L1261.153,1435.83z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1159.669,1372.583c-1.579,2.969-5.121,3.969-7.912,2.231l-17.356-10.806 c-2.801-1.744-3.785-5.569-2.198-8.543l0,0c1.586-2.973,5.141-3.967,7.939-2.222l17.339,10.817 C1160.269,1365.799,1161.248,1369.614,1159.669,1372.583L1159.669,1372.583z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1167.95,1352c1.602,3.001,5.144,4.076,7.91,2.401l0,0c2.764-1.674,3.708-5.461,2.109-8.461 l-9.939-18.641c-1.603-3.006-5.148-4.091-7.921-2.422l0,0c-2.773,1.67-3.721,5.463-2.115,8.47L1167.95,1352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1226.506,1461.696c1.586,2.971,5.091,4.006,7.829,2.314l0,0 c2.736-1.692,3.67-5.469,2.087-8.438l-9.838-18.45c-1.586-2.975-5.096-4.021-7.839-2.334l0,0 c-2.745,1.688-3.683,5.47-2.094,8.447L1226.506,1461.696z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1132.546,1435.234c1.612,2.999,5.176,4.051,7.959,2.351l17.246-10.535 c2.773-1.694,3.72-5.493,2.115-8.488l0,0c-1.605-2.995-5.156-4.052-7.932-2.36l-17.264,10.524 C1131.885,1428.424,1130.934,1432.234,1132.546,1435.234L1132.546,1435.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1233.977,1373.34c1.584,2.981,5.085,4.043,7.819,2.373l16.943-10.349 c2.724-1.664,3.655-5.425,2.078-8.401l0,0c-1.577-2.977-5.065-4.044-7.792-2.382l-16.96,10.338 C1233.328,1366.587,1232.393,1370.358,1233.977,1373.34L1233.977,1373.34z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1191.637,1342.311c0.03,3.43,2.636,6.229,5.82,6.252l0,0c3.182,0.023,5.735-2.737,5.706-6.163 l-0.185-21.274c-0.03-3.427-2.632-6.231-5.814-6.263l0,0c-3.184-0.032-5.742,2.723-5.712,6.153L1191.637,1342.311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1192.734,1468.294c0.03,3.43,2.636,6.2,5.818,6.187l0,0c3.181-0.012,5.734-2.8,5.705-6.226 l-0.185-21.27c-0.03-3.426-2.632-6.201-5.813-6.198l0,0c-3.183,0.003-5.74,2.786-5.711,6.215L1192.734,1468.294z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1122.463,1395.334c0.03,3.451,2.668,6.255,5.89,6.263l19.963,0.05 c3.209,0.008,5.785-2.775,5.755-6.217l0,0c-0.03-3.441-2.655-6.241-5.864-6.252l-19.963-0.072 C1125.021,1389.095,1122.432,1391.883,1122.463,1395.334L1122.463,1395.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1239.693,1395.691c0.03,3.416,2.614,6.191,5.771,6.199l19.557,0.049 c3.144,0.008,5.668-2.747,5.638-6.153l0,0c-0.03-3.406-2.601-6.177-5.745-6.188l-19.558-0.07 C1242.199,1389.515,1239.663,1392.275,1239.693,1395.691L1239.693,1395.691z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000131342876642766121640000010530885862181790608_",
    gradientUnits: "userSpaceOnUse",
    x1: 2555.6057,
    y1: 1610.9084,
    x2: 2407.8328,
    y2: 1953.4739
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF928E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FEB3B1"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000131342876642766121640000010530885862181790608_)"
    },
    d: "M2382.124,1714.981 c0-75.27,61.422-134.793,134.335-133.017c69.938,1.704,124.575,59.62,124.575,129.421c0,69.802-54.637,129.236-124.575,132.882 C2443.546,1848.068,2382.124,1790.251,2382.124,1714.981z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2559.319,1672.393c-0.075-0.214-0.13-0.44-0.207-0.653 c-7.211-19.906-25.546-34.309-47.074-34.733c-28.034-0.553-50.825,22.733-50.825,52.025c0,0.643,0,1.259,0.05,1.878 c-13.522,0.926-24.217,13.894-24.217,28.272c0,3.63,2.835,7.934,6.329,7.977l31.109,0.384l14.35,0.177l35.778,0.441 l24.729,0.305l34.651,0.427c5.954,0.073,10.958-5.882,11.595-12.087c0.136-1.315,0.204-3.319,0.204-4.705 C2595.79,1690.859,2579.541,1672.852,2559.319,1672.393z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2478.184,1745.066l-0.773-0.536c-1.498-1.036-3.506-0.62-4.484,0.927l-8.623,13.623 c-0.982,1.551-0.562,3.647,0.939,4.68l0.775,0.536c1.5,1.033,3.51,0.615,4.49-0.934l8.614-13.62 C2480.101,1748.194,2479.682,1746.1,2478.184,1745.066z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2519.982,1745.522l-0.768-0.535c-1.488-1.032-3.482-0.618-4.454,0.924l-8.564,13.577 c-0.975,1.546-0.558,3.634,0.933,4.664l0.77,0.534c1.49,1.03,3.486,0.613,4.459-0.931l8.556-13.574 C2521.885,1748.639,2521.469,1746.553,2519.982,1745.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2561.497,1745.975l-0.763-0.533c-1.478-1.029-3.458-0.616-4.424,0.921l-8.506,13.531 c-0.969,1.541-0.554,3.622,0.927,4.648l0.764,0.532c1.48,1.026,3.463,0.611,4.429-0.928l8.498-13.528 C2563.388,1749.081,2562.974,1747.002,2561.497,1745.975z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2490.507,1768.29l-0.772-0.534c-1.495-1.032-3.499-0.613-4.476,0.934l-8.606,13.625 c-0.979,1.551-0.56,3.644,0.938,4.674l0.773,0.534c1.497,1.029,3.503,0.608,4.481-0.942l8.597-13.623 C2492.42,1771.411,2492.001,1769.321,2490.507,1768.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2532.222,1768.667l-0.767-0.533c-1.485-1.029-3.475-0.611-4.445,0.931l-8.547,13.579 c-0.973,1.546-0.556,3.632,0.931,4.658l0.768,0.532c1.487,1.026,3.479,0.606,4.45-0.939l8.539-13.577 C2534.121,1771.778,2533.706,1769.694,2532.222,1768.667z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000042714029746265684160000003048977064298951861_",
    gradientUnits: "userSpaceOnUse",
    x1: 2059.8914,
    y1: 1196.3523,
    x2: 1965.5273,
    y2: 1345.7622
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E1473D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E9605A"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000042714029746265684160000003048977064298951861_)"
    },
    d: "M1442.939,1839 c0-120.353,101.127-215.42,221.121-212.456c115.047,2.842,204.887,95.463,204.887,206.98 c0,111.517-89.84,206.448-204.887,212.248C1544.066,2051.82,1442.939,1959.353,1442.939,1839z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1726.128,1773.059c-0.123-0.341-0.212-0.699-0.339-1.038 c-11.811-31.67-41.843-54.6-77.111-55.302c-45.931-0.915-83.278,36.104-83.278,82.706c0,1.023,0,2.004,0.081,2.988 c-22.16,1.46-39.688,21.56-39.688,44.437c0,5.775,4.646,12.104,10.374,12.176l50.98,0.639l23.513,0.295l58.617,0.735 l40.508,0.508l56.751,0.711c9.75,0.122,17.944-8.829,18.987-18.696c0.223-2.091,0.335-5.02,0.335-7.224 C1785.857,1802.209,1759.248,1773.811,1726.128,1773.059z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "1634.015,1872.3 1680.452,1872.854 1654.429,1920.684 1707.532,1921.186 1643.093,1997.85 1657.827,1936.761 1605.59,1936.31  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2831.664,861.567c-5.879,0.225-10.825-4.361-11.048-10.237 c-0.436-11.419-1.372-22.988-2.787-34.388c-0.716-5.768,3.325-11.029,9.053-11.851c0.068-0.01,0.136-0.019,0.206-0.029 c5.836-0.724,11.154,3.422,11.878,9.26c1.488,11.999,2.476,24.179,2.933,36.2c0.211,5.496-3.789,10.179-9.117,10.944 C2832.415,861.518,2832.042,861.555,2831.664,861.567z M2807.14,761.927c-2.953-11.096-6.409-22.169-10.275-32.923 c-1.989-5.531,0.883-11.633,6.417-13.624c5.562-1.979,11.635,0.886,13.625,6.421c4.068,11.313,7.707,22.97,10.817,34.644 c1.513,5.683-1.87,11.518-7.553,13.031c-0.413,0.11-0.827,0.194-1.239,0.253 C2813.663,770.485,2808.543,767.198,2807.14,761.927z M2774.291,677.74c-5.334-10.132-11.174-20.154-17.362-29.793 c-3.176-4.948-1.739-11.538,3.21-14.715c4.948-3.168,11.534-1.738,14.715,3.21c6.516,10.151,12.667,20.708,18.282,31.376 c2.74,5.204,0.741,11.643-4.461,14.386c-1.11,0.583-2.275,0.953-3.449,1.121 C2780.894,683.945,2776.446,681.835,2774.291,677.74z M2723.438,603.014c-7.473-8.695-15.411-17.163-23.591-25.176 c-4.201-4.117-4.271-10.86-0.156-15.06c4.12-4.197,10.859-4.264,15.06-0.155c8.613,8.439,16.969,17.356,24.836,26.502 c3.833,4.459,3.327,11.184-1.133,15.018c-1.595,1.372-3.481,2.189-5.42,2.467 C2729.554,607.109,2725.902,605.876,2723.438,603.014z M2657.205,541.48c-9.195-6.8-18.813-13.305-28.585-19.325 c-5.007-3.089-6.563-9.649-3.479-14.655c3.087-5.011,9.649-6.565,14.653-3.476c10.28,6.334,20.4,13.178,30.075,20.334 c4.729,3.495,5.728,10.164,2.229,14.893c-1.761,2.383-4.329,3.819-7.049,4.209 C2662.373,543.844,2659.551,543.215,2657.205,541.48z M2579.008,496.134c-10.486-4.606-21.3-8.817-32.144-12.519 c-5.566-1.9-8.539-7.954-6.639-13.517c1.9-5.568,7.949-8.541,13.519-6.642c11.411,3.894,22.795,8.329,33.831,13.176 c5.384,2.367,7.832,8.647,5.467,14.034c-1.536,3.498-4.726,5.754-8.249,6.26C2582.892,497.2,2580.896,496.965,2579.008,496.134 z M2184.422,522.424c-3.169-4.954-1.722-11.541,3.234-14.71c10.151-6.49,20.725-12.626,31.423-18.232 c5.21-2.731,11.647-0.721,14.375,4.49c2.73,5.206,0.72,11.643-4.488,14.373c-10.158,5.323-20.197,11.15-29.835,17.315 c-1.323,0.845-2.759,1.362-4.219,1.572C2190.906,527.806,2186.745,526.058,2184.422,522.424z M2492.757,469.267 c-11.242-2.157-22.714-3.853-34.1-5.036c-5.851-0.611-10.101-5.847-9.492-11.696c0.609-5.853,5.845-10.071,11.696-9.49 c11.99,1.248,24.072,3.032,35.91,5.305c5.775,1.109,9.56,6.689,8.451,12.467c-0.879,4.581-4.573,7.909-8.946,8.537 C2495.138,469.518,2493.952,469.495,2492.757,469.267z M2266.674,479.42c-1.979-5.537,0.908-11.632,6.447-13.612 c11.345-4.052,23.016-7.667,34.685-10.753c5.685-1.53,11.513,1.891,13.017,7.576c1.502,5.685-1.89,11.513-7.576,13.017 c-11.09,2.931-22.181,6.367-32.962,10.22c-0.688,0.246-1.385,0.413-2.08,0.513 C2273.295,487.085,2268.406,484.269,2266.674,479.42z M2402.682,462.35c-11.435,0.413-23.001,1.324-34.382,2.712 c-5.839,0.715-11.148-3.44-11.862-9.28c-0.702-5.762,3.336-11.01,9.055-11.83c0.074-0.011,0.151-0.022,0.225-0.028 c11.981-1.466,24.159-2.427,36.193-2.863c5.878-0.208,10.815,4.383,11.028,10.261c0.199,5.489-3.798,10.16-9.118,10.923 C2403.448,462.299,2403.066,462.333,2402.682,462.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2135.817,573.054c2.075-0.298,4.086-1.208,5.737-2.747c4.016-3.745,8.179-7.464,12.369-11.066 c4.462-3.83,4.975-10.556,1.143-15.016c-3.83-4.464-10.559-4.982-15.017-1.141c-4.41,3.784-8.786,7.698-13.014,11.637 c-4.302,4.008-4.541,10.75-0.533,15.05C2128.974,572.426,2132.481,573.532,2135.817,573.054z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2003.57,869.576c5.088-0.73,9.036-5.062,9.125-10.365c0.089-5.489,0.295-11.069,0.614-16.582 c0.339-5.873-4.147-10.908-10.018-11.246c-5.896-0.339-10.907,4.149-11.246,10.018c-0.334,5.805-0.552,11.682-0.647,17.461 c-0.096,5.88,4.593,10.726,10.474,10.823C2002.448,869.695,2003.016,869.656,2003.57,869.576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2455.923,1289.794c-5.855,0.55-11.049-3.753-11.597-9.612 c-0.548-5.855,3.75-11.035,9.61-11.594c11.149-1.044,22.426-2.582,33.648-4.578c5.759-1.045,11.32,2.831,12.35,8.622 c1.03,5.79-2.829,11.319-8.619,12.352c-4.862,0.865-9.72,1.646-14.57,2.342 C2469.825,1288.317,2462.819,1289.15,2455.923,1289.794z M2534.231,1264.094c-1.803-5.595,1.272-11.596,6.869-13.399 c10.747-3.466,21.463-7.42,31.851-11.759c5.414-2.281,11.664,0.294,13.932,5.721c2.266,5.424-0.297,11.662-5.722,13.928 c-10.937,4.569-22.218,8.734-33.527,12.377c-0.587,0.189-1.178,0.325-1.767,0.409 C2540.825,1272.095,2535.847,1269.107,2534.231,1264.094z M2397.91,1291.24c-11.837-0.517-23.815-1.547-35.6-3.068 c-5.833-0.752-9.953-6.091-9.201-11.926c0.752-5.832,6.09-9.943,11.925-9.199c11.192,1.446,22.564,2.425,33.804,2.913 c5.876,0.258,10.432,5.228,10.176,11.106c-0.228,5.198-4.146,9.361-9.116,10.074 C2399.251,1291.232,2398.586,1291.269,2397.91,1291.24z M2618.483,1228.829c-2.989-5.064-1.308-11.596,3.758-14.583 c9.709-5.73,19.289-11.945,28.473-18.469c4.797-3.411,11.441-2.284,14.848,2.514c3.406,4.794,2.281,11.44-2.512,14.846 c-9.672,6.871-19.761,13.416-29.983,19.45c-1.236,0.728-2.558,1.182-3.896,1.374 C2625.027,1234.556,2620.743,1232.657,2618.483,1228.829z M2305.443,1276.82c-11.426-3.106-22.879-6.746-34.043-10.818 c-5.525-2.015-8.37-8.124-6.357-13.649c2.014-5.529,8.128-8.373,13.654-6.358c10.605,3.866,21.483,7.324,32.334,10.273 c5.676,1.544,9.027,7.396,7.483,13.072c-1.15,4.229-4.692,7.166-8.768,7.75 C2308.349,1277.29,2306.888,1277.214,2305.443,1276.82z M2218.379,1242.471c-10.496-5.542-20.88-11.592-30.865-17.98 c-4.954-3.173-6.4-9.756-3.23-14.712c3.176-4.961,9.76-6.405,14.71-3.228c9.488,6.069,19.356,11.819,29.33,17.088 c5.201,2.746,7.191,9.189,4.445,14.391c-1.656,3.133-4.654,5.101-7.913,5.568 C2222.706,1243.905,2220.444,1243.562,2218.379,1242.471z M2140.867,1189.963c-9.045-7.7-17.865-15.87-26.215-24.274 c-4.146-4.175-4.121-10.915,0.051-15.061c4.178-4.15,10.917-4.121,15.06,0.051c7.933,7.99,16.313,15.747,24.911,23.066 c4.478,3.813,5.018,10.535,1.205,15.011c-1.751,2.058-4.114,3.283-6.593,3.639 C2146.367,1192.813,2143.289,1192.024,2140.867,1189.963z M2076.657,1121.797c-7.142-9.49-13.961-19.397-20.266-29.444 c-3.127-4.981-1.624-11.555,3.359-14.682c4.973-3.121,11.553-1.619,14.68,3.362c5.986,9.538,12.461,18.944,19.246,27.96 c3.536,4.699,2.594,11.374-2.106,14.91c-1.485,1.117-3.165,1.786-4.882,2.033 C2082.968,1126.469,2079.079,1125.013,2076.657,1121.797z M2028.969,1041.146c-4.863-10.804-9.327-21.961-13.27-33.162 c-1.953-5.549,0.961-11.632,6.509-13.583c5.531-1.945,11.627,0.959,13.581,6.508c3.745,10.641,7.986,21.236,12.603,31.501 c2.414,5.361,0.022,11.667-5.341,14.079c-0.934,0.42-1.896,0.697-2.862,0.835 C2035.61,1047.98,2030.962,1045.575,2028.969,1041.146z M2000.184,952.085c-1.764-8.551-3.287-17.263-4.524-25.89 c-0.448-3.125-0.86-6.243-1.238-9.362c-0.707-5.836,3.364-11.249,9.29-11.851c5.838-0.711,11.146,3.449,11.855,9.289 c0.36,2.962,0.75,5.931,1.176,8.9c1.177,8.203,2.622,16.48,4.299,24.611c1.189,5.759-2.518,11.392-8.278,12.58 c-0.217,0.043-0.433,0.083-0.65,0.114C2006.587,961.269,2001.326,957.628,2000.184,952.085z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2702.373,1178.946c2.096-0.301,4.121-1.225,5.779-2.783c4.199-3.951,8.393-8.066,12.467-12.231 c4.114-4.204,4.041-10.947-0.164-15.059c-4.206-4.112-10.943-4.045-15.059,0.164c-3.87,3.955-7.855,7.863-11.84,11.616 c-4.282,4.027-4.488,10.767-0.458,15.051C2695.569,1178.329,2699.058,1179.422,2702.373,1178.946z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2708.095,996.467c1.095-1.82,0.916-4.133-0.448-5.762l-38.875-46.46 c8.682-26.926,13.133-55.429,12.746-84.54l50.789-32.947c1.781-1.156,2.633-3.315,2.121-5.376l-17.513-70.521 c-0.511-2.062-2.275-3.571-4.389-3.759l-60.303-5.36c-13.276-25.91-30.544-49.021-50.813-68.757l12.624-59.248 c0.442-2.077-0.482-4.206-2.301-5.301l-62.249-37.483c-1.819-1.095-4.134-0.916-5.762,0.447l-46.459,38.875 c-26.925-8.683-55.429-13.134-84.541-12.746l-32.947-50.789c-1.156-1.782-3.314-2.634-5.375-2.122l-70.523,17.512 c-2.061,0.513-3.57,2.276-3.758,4.39l-5.36,60.303c-25.911,13.276-49.021,30.544-68.757,50.814l-59.249-12.625 c-2.077-0.442-4.206,0.481-5.301,2.301l-37.484,62.249c-1.095,1.819-0.915,4.133,0.446,5.76l38.876,46.461 c-8.683,26.925-13.133,55.428-12.746,84.54l-50.789,32.948c-1.782,1.155-2.634,3.314-2.122,5.375l17.513,70.523 c0.512,2.061,2.274,3.57,4.389,3.758l60.303,5.361c13.276,25.91,30.544,49.021,50.813,68.757l-12.624,59.248 c-0.443,2.076,0.48,4.205,2.301,5.301l62.25,37.483c1.819,1.095,4.133,0.916,5.761-0.447l46.46-38.875 c26.925,8.683,55.428,13.133,84.54,12.746l32.947,50.789c1.156,1.78,3.314,2.633,5.375,2.121l70.522-17.513 c2.061-0.512,3.571-2.274,3.758-4.39l5.36-60.301c25.911-13.276,49.021-30.545,68.757-50.814l59.249,12.625 c2.076,0.443,4.206-0.482,5.301-2.3L2708.095,996.467z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2415.751,936.054c-40.273-0.158-72.912-33.046-72.756-73.324 c0.074-19.51,7.743-37.823,21.593-51.564c13.845-13.74,32.216-21.271,51.729-21.191c40.274,0.157,72.912,33.046,72.757,73.323 c-0.143,36.641-27.378,66.959-62.622,72.014C2422.958,935.814,2419.382,936.067,2415.751,936.054z M2376.588,823.262 c-10.619,10.537-16.498,24.576-16.556,39.537c-0.118,30.876,24.906,56.098,55.784,56.217 c30.887,0.13,56.098-24.906,56.219-55.786c0.118-30.876-24.906-56.098-55.784-56.217c-2.8-0.01-5.565,0.185-8.287,0.575 C2396.144,809.283,2385.219,814.7,2376.588,823.262z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2439.95,1039.951c6.053-0.868,12.098-2.046,18.113-3.539l0,0 c1.893-0.469,3.78-0.971,5.658-1.501c9.259-2.618,18.294-5.969,26.968-9.999c0.118-0.055,0.236-0.11,0.355-0.164 c0.335-0.157,0.669-0.314,1.003-0.476c0.651-0.308,1.299-0.624,1.946-0.939c1.7-0.832,2.598-2.646,2.345-4.425 c-0.062-0.432-0.193-0.863-0.395-1.276c-1.035-2.113-3.587-2.978-5.698-1.948c-10.87,5.329-22.387,9.519-34.232,12.457 c-58.832,14.62-118.249-3.283-159.239-42.236c-22.802-21.663-39.901-49.842-48.025-82.565 c-1.426-5.738-2.552-11.506-3.378-17.28c-5.569-38.855,2.33-78.117,22.852-112.196 c23.571-39.147,60.978-66.773,105.325-77.785c91.593-22.735,184.531,33.255,207.264,124.801 c1.402,5.644,2.513,11.339,3.331,17.059c3.551,24.786,1.638,50.073-5.688,74.039c-0.189,0.62-0.231,1.247-0.143,1.849 c0.227,1.581,1.34,2.972,2.971,3.469c2.253,0.681,4.633-0.572,5.32-2.83c7.691-25.162,9.702-51.712,5.974-77.732 c-0.859-6.004-2.025-11.98-3.495-17.905c-23.867-96.116-121.505-154.878-217.586-131.02 c-46.559,11.561-85.825,40.563-110.571,81.66c-21.546,35.777-29.836,76.994-23.992,117.785 c0.869,6.061,2.051,12.116,3.545,18.138c11.563,46.56,40.563,85.829,81.659,110.575 C2357.922,1037.516,2399.152,1045.802,2439.95,1039.951z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M3232.357,1087.671c2.817-0.404,5.148-2.614,5.573-5.575c0.797-5.526,1.437-11.153,1.901-16.722 c0.302-3.619-2.386-6.796-6.009-7.101c-3.624-0.317-6.798,2.39-7.101,6.009c-0.442,5.307-1.052,10.67-1.811,15.944 c-0.519,3.592,1.977,6.925,5.572,7.448C3231.121,1087.764,3231.75,1087.758,3232.357,1087.671z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M3234.271,1037.204c-3.629,0.144-6.691-2.674-6.838-6.307 c-0.376-9.16-1.225-18.408-2.527-27.482c-0.275-1.914-0.573-3.831-0.89-5.752c-0.588-3.581,1.837-6.967,5.421-7.558 c3.411-0.424,6.967,1.837,7.562,5.424c0.33,2.01,0.641,4.016,0.928,6.018c1.364,9.512,2.255,19.208,2.646,28.815 c0.141,3.399-2.331,6.304-5.63,6.777C3234.725,1037.171,3234.5,1037.19,3234.271,1037.204z M3216.585,965.097 c-3.129-10.666-6.946-21.235-11.347-31.408c-1.442-3.336,0.089-7.202,3.425-8.648c3.319-1.43,7.206,0.089,8.648,3.425 c4.614,10.661,8.617,21.742,11.896,32.926c1.022,3.487-0.975,7.141-4.461,8.167c-0.305,0.089-0.617,0.153-0.925,0.197 C3220.634,970.214,3217.517,968.273,3216.585,965.097z M3190.085,903.917c-5.638-9.561-11.937-18.865-18.724-27.664 c-2.216-2.874-1.684-7.007,1.191-9.223c2.886-2.224,7.005-1.693,9.226,1.189c7.118,9.225,13.723,18.991,19.637,29.012 c1.844,3.129,0.807,7.165-2.322,9.009c-0.764,0.446-1.58,0.726-2.406,0.845 C3194.128,907.452,3191.482,906.281,3190.085,903.917z M3149.363,851.117c-7.823-7.898-16.209-15.383-24.917-22.233 c-2.856-2.251-3.349-6.385-1.101-9.238c2.242-2.846,6.378-3.348,9.235-1.104c9.136,7.19,17.924,15.034,26.13,23.318 c2.557,2.58,2.535,6.748-0.045,9.305c-1.044,1.026-2.34,1.64-3.689,1.833C3152.983,853.284,3150.888,852.657,3149.363,851.117z  M3096.984,809.858c-9.504-5.755-19.451-10.974-29.57-15.518c-3.311-1.485-4.792-5.379-3.304-8.694 c1.488-3.315,5.379-4.802,8.695-3.304c10.605,4.76,21.032,10.234,30.994,16.261c3.105,1.884,4.101,5.927,2.22,9.032 c-1.063,1.755-2.815,2.837-4.697,3.107C3099.87,810.949,3098.338,810.676,3096.984,809.858z M3036.177,782.565 c-10.608-3.267-21.517-5.901-32.432-7.827c-3.575-0.63-5.966-4.044-5.333-7.619c0.633-3.575,4.032-5.958,7.621-5.337 c11.444,2.019,22.891,4.783,34.019,8.21c3.469,1.073,5.418,4.751,4.349,8.22c-0.775,2.512-2.917,4.228-5.355,4.578 C3038.114,782.924,3037.138,782.862,3036.177,782.565z M2970.57,770.977c-11.051-0.563-22.284-0.438-33.39,0.376 c-3.623,0.26-6.774-2.461-7.037-6.083c-0.267-3.621,2.456-6.718,6.082-7.043c11.643-0.845,23.421-0.978,35.011-0.388 c3.628,0.187,6.42,3.277,6.237,6.905c-0.162,3.19-2.577,5.736-5.629,6.174C2971.43,770.976,2971.004,770.999,2970.57,770.977z  M2863.465,780.135c-1.137-3.451,0.737-7.166,4.189-8.303c9.551-3.148,19.439-5.825,29.36-7.955 c1.507-0.332,3.01-0.639,4.518-0.94c3.525-0.804,7.025,1.614,7.723,5.187c0.703,3.565-1.618,7.019-5.183,7.725 c-1.415,0.275-2.829,0.569-4.266,0.885c-9.497,2.037-18.929,4.59-28.037,7.59c-0.375,0.125-0.755,0.212-1.13,0.266 C2867.539,785.033,2864.477,783.208,2863.465,780.135z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M2993.091,1323.36c-11.367,1.481-22.924,2.275-34.349,2.376 c-3.63,0.028-6.602-2.889-6.633-6.524c-0.032-3.636,2.915-6.57,6.524-6.633c10.895-0.09,21.918-0.853,32.763-2.266 c3.602-0.471,6.903,2.073,7.37,5.672c0.464,3.573-2.031,6.852-5.585,7.361 C2993.151,1323.352,2993.119,1323.356,2993.091,1323.36z M3018.929,1312.114c-0.896-3.518,1.23-7.1,4.75-7.994 c10.588-2.699,21.121-6.066,31.304-10.012c3.371-1.295,7.197,0.369,8.508,3.763c1.313,3.387-0.37,7.191-3.757,8.507 c-10.672,4.133-21.71,7.663-32.807,10.487c-0.235,0.06-0.465,0.106-0.7,0.14 C3022.946,1317.476,3019.768,1315.407,3018.929,1312.114z M2924.332,1323.917c-11.394-1.312-22.806-3.328-33.915-5.998 c-3.532-0.85-5.709-4.405-4.859-7.933c0.846-3.535,4.387-5.697,7.929-4.862c10.598,2.549,21.481,4.473,32.352,5.73 c3.609,0.417,6.196,3.68,5.781,7.282c-0.35,3.035-2.711,5.347-5.598,5.76 C2925.476,1323.973,2924.91,1323.984,2924.332,1323.917z M3082.143,1289.291c-1.718-3.2-0.512-7.188,2.688-8.905 c9.628-5.164,19.032-10.971,27.954-17.266c2.968-2.087,7.073-1.378,9.165,1.579c2.094,2.97,1.387,7.075-1.582,9.169 c-9.354,6.604-19.22,12.698-29.319,18.111c-0.699,0.373-1.435,0.608-2.175,0.714 C3086.215,1293.074,3083.485,1291.792,3082.143,1289.291z M2857.5,1307.845c-10.72-4.004-21.307-8.709-31.472-13.98 c-3.225-1.672-4.482-5.645-2.81-8.87c1.672-3.225,5.641-4.489,8.87-2.81c9.693,5.034,19.79,9.517,30.016,13.332 c3.401,1.271,5.132,5.059,3.858,8.466c-0.869,2.331-2.928,3.879-5.233,4.209 C2859.678,1308.343,2858.57,1308.243,2857.5,1307.845z M2796.466,1276.204c-9.468-6.468-18.627-13.571-27.222-21.104 c-2.73-2.392-3.005-6.545-0.61-9.276c2.389-2.731,6.547-3.009,9.283-0.611c8.197,7.182,16.936,13.956,25.971,20.129 c3,2.048,3.769,6.143,1.72,9.142c-1.083,1.583-2.736,2.547-4.501,2.8C2799.537,1277.51,2797.879,1277.169,2796.466,1276.204z  M2744.76,1230.858c-7.651-8.552-14.841-17.65-21.371-27.031c-2.076-2.985-1.34-7.082,1.642-9.157 c2.979-2.076,7.08-1.334,9.155,1.639c6.225,8.951,13.082,17.623,20.38,25.772c2.422,2.708,2.192,6.869-0.518,9.288 c-1.003,0.903-2.205,1.432-3.445,1.61C2748.498,1233.281,2746.286,1232.56,2744.76,1230.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M3144.013,1253.761c1.256-0.18,2.472-0.725,3.483-1.642c4.168-3.784,8.241-7.71,12.113-11.665 c2.538-2.597,2.495-6.763-0.101-9.304c-2.599-2.528-6.759-2.489-9.304,0.102c-3.689,3.774-7.578,7.518-11.553,11.131 c-2.69,2.442-2.887,6.604-0.446,9.291C3139.73,1253.35,3141.924,1254.06,3144.013,1253.761z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7D97F4"
    },
    d: "M3151.619,1128.773c0.732-1.218,0.613-2.766-0.299-3.856l-26.013-31.09 c5.809-18.017,8.787-37.09,8.528-56.57l33.986-22.047c1.192-0.774,1.762-2.217,1.42-3.597l-11.719-47.189 c-0.342-1.38-1.522-2.39-2.936-2.515l-40.352-3.586c-8.884-17.339-20.438-32.803-34.002-46.009l8.447-39.646 c0.296-1.39-0.323-2.814-1.54-3.547l-41.654-25.082c-1.217-0.733-2.766-0.613-3.855,0.299l-31.088,26.013 c-18.017-5.81-37.091-8.788-56.571-8.529l-22.046-33.986c-0.774-1.192-2.218-1.762-3.596-1.42l-47.191,11.719 c-1.379,0.343-2.388,1.523-2.514,2.938l-3.587,40.352c-17.338,8.884-32.803,20.438-46.009,34.002l-39.647-8.448 c-1.389-0.296-2.814,0.322-3.547,1.539l-25.082,41.655c-0.733,1.217-0.612,2.765,0.299,3.854l26.014,31.09 c-5.81,18.017-8.789,37.089-8.529,56.57l-33.986,22.047c-1.192,0.772-1.762,2.217-1.42,3.596l11.719,47.191 c0.343,1.379,1.522,2.388,2.938,2.514l40.352,3.586c8.884,17.339,20.439,32.803,34.002,46.009l-8.448,39.646 c-0.296,1.389,0.322,2.814,1.539,3.547l41.655,25.082c1.218,0.733,2.766,0.613,3.856-0.298l31.089-26.014 c18.017,5.81,37.09,8.788,56.571,8.529l22.046,33.986c0.774,1.191,2.218,1.762,3.597,1.42l47.19-11.719 c1.379-0.343,2.389-1.522,2.514-2.937l3.587-40.351c17.338-8.884,32.802-20.439,46.009-34.002l39.647,8.448 c1.389,0.297,2.814-0.323,3.547-1.539L3151.619,1128.773z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2955.996,1089.224c-13.293-0.047-25.768-5.272-35.128-14.708 c-9.36-9.429-14.487-21.944-14.434-35.235c0.105-27.431,22.476-49.62,49.947-49.562c27.435,0.114,49.664,22.518,49.555,49.944 c-0.05,13.29-5.272,25.765-14.705,35.125c-7.669,7.608-17.374,12.42-27.877,13.926 C2960.94,1089.06,2958.479,1089.231,2955.996,1089.224z M2919.587,1039.328c-0.038,9.778,3.732,18.984,10.62,25.926 c6.883,6.936,16.062,10.779,25.837,10.817l0,0c9.776,0.025,18.98-3.735,25.922-10.622c6.939-6.88,10.778-16.062,10.817-25.833 c0.078-20.179-16.273-36.659-36.452-36.743c-1.821-0.004-3.61,0.122-5.362,0.373 C2933.308,1005.778,2919.658,1020.973,2919.587,1039.328z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BDD0FB"
    },
    d: "M2972.844,1161.535c4.12-0.591,8.242-1.397,12.365-2.416 c8.187-2.031,16.175-4.896,23.762-8.528c0.34-0.166,0.679-0.331,1.019-0.497c2.626-1.285,4.011-4.086,3.621-6.833 c-0.096-0.667-0.298-1.333-0.61-1.969c-1.597-3.262-5.539-4.592-8.799-3.008c-7.051,3.458-14.507,6.168-22.158,8.065l-0.003,0 c-0.419,0.105-0.843,0.205-1.261,0.304c-18.149,4.323-36.689,3.958-54.232-0.793c-9.522-2.58-18.755-6.46-27.471-11.601 c-0.071-0.042-0.142-0.083-0.213-0.125c-0.217-0.132-0.433-0.256-0.646-0.388c-25.341-15.262-43.227-39.476-50.355-68.186 c-0.926-3.715-1.652-7.446-2.188-11.185c-3.604-25.154,1.51-50.571,14.795-72.638c15.262-25.342,39.478-43.221,68.185-50.349 c28.693-7.113,58.478-2.651,83.822,12.604c25.341,15.261,43.227,39.476,50.355,68.186c0.91,3.652,1.627,7.34,2.157,11.04 c2.299,16.049,1.061,32.416-3.683,47.93c-0.291,0.957-0.357,1.926-0.22,2.854c0.35,2.442,2.07,4.59,4.587,5.358 c3.477,1.052,7.15-0.889,8.215-4.371c5.306-17.36,6.693-35.676,4.125-53.626c-0.594-4.145-1.396-8.268-2.411-12.354 c-7.978-32.124-27.986-59.215-56.342-76.289c-28.352-17.068-61.643-22.105-93.774-14.103 c-32.122,7.975-59.212,27.979-76.283,56.338c-14.866,24.682-20.586,53.119-16.552,81.261c0.599,4.177,1.412,8.357,2.443,12.51 C2850.54,1130.914,2910.73,1170.443,2972.844,1161.535z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimatechange);
export default __webpack_public_path__ + "static/media/climatechange.cb3c4f35a4c16b704534de48ff97ce35.svg";
export { ForwardRef as ReactComponent };